import { useSearchUserApiV1UsersUserIdGetQuery } from "@/store/baseClientApi";
import { useAuth0 } from "@auth0/auth0-react";

const EMAIL_VERIFIED_POLLING_INTERVAL = 5000; // Polling milliseconds

/**
 * React hook to check if the current Auth0 user's email is verified.
 *
 * This hook polls the backend for the user's email verification status every 5 seconds.
 * It returns the latest email verification status, loading state, error, and userId.
 *
 * @returns {Object} An object containing:
 *   - emailVerified: boolean — true if the user's email is verified
 *   - isLoading: boolean — true if loading
 *   - error: any — error from Auth0 or backend
 *   - userId: string | undefined — the Auth0 user id
 */
export const useUserEmailVerified = () => {
  const { user, isLoading, error } = useAuth0();

  const {
    data,
    error: getUserError,
    isLoading: loadingUser
  } = useSearchUserApiV1UsersUserIdGetQuery(
    { userId: encodeURI(user?.sub ?? "") },
    {
      skip: user?.sub === undefined,
      pollingInterval: EMAIL_VERIFIED_POLLING_INTERVAL
    }
  );

  return {
    emailVerified: user?.email_verified || data?.email_verified || false,
    isLoading: isLoading || loadingUser,
    error: error || getUserError,
    userId: user?.sub
  };
};
